import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path d="M7.32811 3.0625C7.32811 2.88128 7.18121 2.73438 6.99999 2.73438C6.81877 2.73438 6.67186 2.88128 6.67186 3.0625V6.49115H3.06174C2.88052 6.49115 2.73361 6.63806 2.73361 6.81928C2.73361 7.00049 2.88052 7.1474 3.06174 7.1474H6.67186V10.9375C6.67186 11.1187 6.81877 11.2656 6.99999 11.2656C7.18121 11.2656 7.32811 11.1187 7.32811 10.9375V7.1474H10.938C11.1192 7.1474 11.2661 7.00049 11.2661 6.81928C11.2661 6.63806 11.1192 6.49115 10.938 6.49115H7.32811V3.0625Z" fill="#475161" />
    </svg>
  )
}

export default SvgComponent
